/**
 * RecommendationsProvider
 * Contain most logic handing with Omnitech Api
 */

import React from 'react'
import RecommendationsContext from './recommendations-context'
import { fetchRecommendations } from './recommendations-api'

export default function RecommendationsProvider({ children }) {
  const state = {
    fetchRecommendations
  }
  return (
    <RecommendationsContext.Provider value={state}>
      {children}
    </RecommendationsContext.Provider>
  )
}
